import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { deleteEntity, get, patch, post, postFormData } from "~/Services/Request";
export const useGetRequest = <T>(segment: string, enabled = true) => {
    return useQuery<{ value: T[] }>({
        queryKey: [segment],
        queryFn: () => get<{ value: T[] }>("/api/v1/admin/" + segment),
        enabled,
        select: data => {
            return data;
        },
    });
};
export const usePostModel = <TModel, TResponse = TModel>(segment: string) => {
    const queryClient = useQueryClient();
    const { displayError } = useErrorHandler();
    return useMutation<TResponse, any, TModel, any>({
        mutationFn: async model => {
            return await PostModel<TModel, TResponse>(model, segment);
        },
        onSettled: async () => {
            await queryClient.invalidateQueries({ queryKey: [segment] });
        },
        onError: (error, variables, context) => {
            displayError(error);
        },
    });
};
export const usePostFormData = (segment: string) => {
    const queryClient = useQueryClient();
    const { displayError } = useErrorHandler();
    return useMutation({
        mutationFn: async (model: FormData) => {
            const result = await PostFormData(model, segment);
            return result;
        },
        onSettled: async () => {
            await queryClient.invalidateQueries({ queryKey: [segment] });
        },
        onError: (error, variables, context) => {
            displayError(error);
        },
    });
};

const PostModel = <TModel, TResponse = TModel>(model: TModel, segment: string) => {
    let endpoint = "/api/v1/admin/" + segment;
    return post<TResponse>(endpoint, model);
};

const PostFormData = (model: FormData, segment: string) => {
    let endpoint = "/api/v1/admin/" + segment;
    return postFormData(endpoint, model);
};

function useErrorHandler() {
    return {
        displayError: (error: any) => {
            console.log(error);
        },
    };
}
